export default {"src":"/_next/static/media/OXY.0539c86d.svg","height":18,"width":18};